import { createReducer } from "@reduxjs/toolkit";
import { completeCheckout, setCheckout } from "./actions";

const saveCustomerData = (state, payload) => {
  state.name = payload.name;
  state.phone = payload.phone;
  state.email = payload.email;
  state.apartment_number = payload.apartment_number;
  state.floor = payload.floor;
  state.business = payload.business;
};

export default createReducer(
  {
    name: "",
    phone: "",
    email: "",
    apartment_number: "",
    floor: "",
    business: "",
  },
  {
    [setCheckout]: (state, { payload }) => saveCustomerData(state, payload),
    [completeCheckout]: (state, { payload }) =>
      saveCustomerData(state, payload),
  }
);
